import { VersionedAbstractEntity } from "../VersionedAbstractEntity";
export default class ChecklistType extends VersionedAbstractEntity {
    name;
    defaultBook;
    checkpoints;
    constructor(checklistType = {}) {
        super();
        this.defaultBook = undefined;
        Object.assign(this, checklistType);
    }
}
//# sourceMappingURL=ChecklistType.js.map